<template>
    <v-dialog v-model="$store.state.productCode.edit" max-width="600px">
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title> New Product Code </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.productCode.edit = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-combobox
                                label="Select Customer"
                                dense
                                :items="customers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="customer"
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                        <v-col>
                            <v-combobox
                                label="Select Terminal"
                                dense
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="terminal"
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-combobox
                                label="Select Supplier"
                                dense
                                :items="suppliers"
                                :item-text="'Supplier'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="supplier"
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                        <v-col>
                            <v-combobox
                                label="Select Product"
                                dense
                                :items="products"
                                :item-text="'Product'"
                                :item-value="'ProductID'"
                                auto-select-first
                                v-model="product"
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                name="Code"
                                label="Code"
                                v-model="code"
                                :rules="[v => !!v || 'Required']"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                name="Consignor"
                                label="Consignor"
                                v-model="consignor"
                                :rules="[v => !!v || 'Required']"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                name="Consignee"
                                label="Consignee"
                                v-model="consignee"
                                :rules="[v => !!v || 'Required']"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                name="Destination"
                                label="Destination"
                                v-model="destination"
                                :rules="[v => !!v || 'Required']"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn color="primary" @click="validate" class="ma-2"
                            >Save</v-btn
                        >
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Drivers',
    props: ['edt', 'relation'],
    data: function() {
        return {
            dialog: false,
            dataLoading: true,
            products: [],
            product: [],
            suppliers: [],
            supplier: [],
            terminals: [],
            customers: [],
            customer: [],
            code: null,
            consignee: null,
            consignor: null,
            destination: null,
            terminal: [],
            producCode: null
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        dialog(val) {
            val || this.cancel();
        }
    },

    mounted() {
        this.code = this.edt.Code;
        this.consignee = this.edt.Consignee;
        this.consignor = this.edt.Consignor;
        this.destination = this.edt.Destination;
        let index = this.relation.findIndex(elm => {
            return elm.ID == this.edt.ID;
        });
        this.relation.splice(index, 1);
        this.loadTerminals();
        this.loadCustomers();
        this.loadSuppliers();
        this.loadProducts();
    },

    methods: {
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active')
                .then(response => {
                    console.log(response.data.data);
                    this.suppliers = response.data.data;

                    let index = this.suppliers.findIndex(elm => {
                        return elm.id == this.edt.Supplier;
                    });
                    console.log(index);
                    this.supplier = this.suppliers[index];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;

                    let index = this.customers.findIndex(elm => {
                        return elm.id == this.edt.Customer;
                    });
                    console.log(index);
                    this.customer = this.customers[index];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active')
                .then(response => {
                    this.products = response.data.data;
                    console.log(this.products);

                    let index = this.products.findIndex(elm => {
                        return elm.ProductID == this.edt.Product;
                    });
                    console.log(index);
                    this.product = this.products[index];
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        loadTerminals: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                    console.log(this.terminals);

                    let index = this.terminals.findIndex(elm => {
                        return elm.id == this.edt.Terminal;
                    });
                    console.log(index);
                    this.terminal = this.terminals[index];
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        checkExistCode: async function() {
            var exist = false;
            await this.relation.forEach(elm => {
                if (
                    elm.Supplier == this.supplier.id &&
                    elm.Terminal == this.terminal.id &&
                    elm.Product == this.product.ProductID &&
                    elm.Customer == this.customer.id
                ) {
                    exist = true;
                }
            });
            return exist;
        },
        async validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                let ext = await this.checkExistCode();
                if (ext == true) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'This combination has a code already'
                    });
                } else {
                    this.edtProducCode();
                }
            }
        },
        edtProducCode: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                Supplier: this.supplier.id,
                Terminal: this.terminal.id,
                Customer: this.customer.id,
                Product: this.product.ProductID,
                Code: this.code,
                Consignee: this.consignee,
                Consignor: this.consignor,
                Destination: this.destination
            };
            console.log(params);
            axios
                .put('realation-product-code/' + this.edt.ID, params)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Product Code Save successful'
                    });
                    this.$store.state.productCode.watch = true;
                    this.$store.state.productCode.edit = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
